import { useMemo } from "react";
import * as CONST from "../../app/constants";
import { NavigationLinkButton } from "../RegularComponents";

import "./BranchCard.style.scss";
import { Button } from "../../components/RegularComponents";
import { isRenewalTypeLicencingSubType } from "../../redux/slice/applicationsUtils";
export const BranchCard = (props) => {
  const { branchApplication, onActionClick } = props;
  const { licenceStatus, licenceNumber, endDate, agentName, licencingSubType, markedDoNotRenew } =
    branchApplication;

  const branchLicenceStatusComponent = (licenceSubType) => {
    if (licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
      return <span className="active">Active</span>;
    } else if (licenceStatus === CONST.LICENCE_STATUS_EXPIRED) {
      return <span className="expired">Expired</span>;
    } else if (licenceStatus === CONST.LICENCE_STATUS_SUSPENDED) {
      return <span className="suspended">Suspended</span>;
    } else if (licenceStatus === CONST.LICENCE_STATUS_REVOKED) {
      return <span className="revoked">Revoked</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) {
      return <span className="denied">Cancelled by client</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED) {
      return <span className="denied">Cancelled</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_SUBMITTED) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_DENIED) {
      return <span className="denied">Denied</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_CANCELLED) {
      return <span className="denied">Cancelled</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (
      licenceStatus === CONST.APPLICATION_STATUS_UNREAD ||
      licenceStatus === CONST.APPLICATION_STATUS_OPENED
    ) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING) {
      return <span className="pending">Pending</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_ACTION_REQUIRED) {
      return <span className="cancelled">Action required</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
      return <span className="active">Approved</span>;
    } else if (
      licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT &&
      licenceSubType !== CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION &&
      !isRenewalTypeLicencingSubType(licencingSubType)
    ) {
      return (
        <span className="pending_payment">
          <NavigationLinkButton
            text="Continue draft"
            style={{
              backgroundColor: "transparent",
              paddingLeft: "0px"
            }}
            onClick={() => {
              // set the collector as current collector
              // and navigate to the details screen
              onActionClick("continue_draft", branchApplication.applicationId);
            }}
          />
        </span>
      );
    }

    // the applications applied for renewal were anyway approved!
    if (isRenewalTypeLicencingSubType(licencingSubType)) {
      return <span className="active">Active</span>;
    }

    return null;
  };

  const actionsObj = useMemo(() => {
    const action = (action) => () => onActionClick(action, branchApplication.applicationId);

    if (isRenewalTypeLicencingSubType(licencingSubType)) {
      if (
        licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT ||
        licenceStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY ||
        licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
        licenceStatus === CONST.APPLICATION_STATUS_UNREAD ||
        licenceStatus === CONST.APPLICATION_STATUS_OPENED ||
        licenceStatus === CONST.APPLICATION_STATUS_PENDING
      ) {
        return {
          primaryButtonText: "View Only",
          onClick: action("branch_details")
        };
      }
    }

    switch (licenceStatus) {
      case CONST.APPLICATION_STATUS_PENDING_PAYMENT:
        return {
          primaryButtonText: "Edit",
          onClick: action("continue_draft")
        };
      default:
        return {
          primaryButtonText: "View Only",
          onClick: action("branch_details")
        };
    }
  }, [licenceStatus, branchApplication.applicationId, licencingSubType, onActionClick]);

  const submittedAt = useMemo(() => {
    switch (licenceStatus) {
      case CONST.APPLICATION_STATUS_ACTION_REQUIRED:
      case CONST.APPLICATION_STATUS_SUBMITTED:
      case CONST.APPLICATION_STATUS_UNDER_REVIEW:
      case CONST.APPLICATION_STATUS_UNREAD:
      case CONST.APPLICATION_STATUS_PENDING:
      case CONST.APPLICATION_STATUS_PENDING_AGENCY:
        return `Submitted on ${branchApplication.submittedDate}`;
      case CONST.APPLICATION_STATUS_PENDING_PAYMENT:
        if (isRenewalTypeLicencingSubType(licencingSubType)) {
          return "Payment pending for renewal";
        }
        return branchApplication.lastModified
          ? `Last modified on ${branchApplication.lastModified}`
          : "";
      case CONST.LICENCE_STATUS_REVOKED:
        return `Revoked on ${branchApplication.lastModified}`;
      case CONST.APPLICATION_STATUS_DENIED:
        return `Denied on ${branchApplication.lastModified}`;
      case CONST.LICENCE_STATUS_SUSPENDED:
        return `Suspended on ${branchApplication.lastModified}`;
      case CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
      case CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED:
        return branchApplication.lastModified
          ? `Withdrawn on ${branchApplication.lastModified}`
          : null;
      default:
        if (markedDoNotRenew) {
          return "Not submitted for renewal";
        }
        return null;
    }
  }, [
    licenceStatus,
    branchApplication.submittedDate,
    branchApplication.lastModified,
    licencingSubType,
    markedDoNotRenew
  ]);

  return (
    <div className="agentCard">
      <div className="agentCard_title">
        <div className="agentCard_title_text">
          <div className="agentCard_title_main">Branch</div>
          <div className="agentCard_title_status">
            {branchLicenceStatusComponent(licencingSubType)}
          </div>
          <div className="agentCard_title_licence">{licenceNumber}</div>
          {endDate && <div className="agentCard_title_validity">Valid Until {endDate}</div>}
          {submittedAt && <div className="agentCard_title_validity">{submittedAt}</div>}
        </div>
        {/* <div className="agentCard_title_icon">
                    <img 
                        src={iconFromApplicationStatus()}
                        alt="img" 
                    />
                </div> */}
      </div>
      <div className="agentCard_body">
        <div className="agentCard_body_name" style={{ fontSize: "1.5em" }}>
          {agentName}
        </div>

        <div className="agentCard_body_links">
          {actionsObj && (
            <div style={{ display: "flex", flexGrow: 1 }}>
              {actionsObj.primaryButtonText && (
                <Button
                  text={actionsObj.primaryButtonText}
                  onClick={actionsObj.onClick}
                  id="ns-edit"
                  buttonType="regular_primary"
                />
              )}

              {actionsObj.secondaryButtonText && (
                <NavigationLinkButton
                  text={actionsObj.secondaryButtonText}
                  onClick={actionsObj.onSecondaryClick}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
